import { Select as ChakraSelect } from "@chakra-ui/react";

import styled, { useTheme } from "styled-components";
import { Text } from "../typography/Texts";
import { SelectProps } from "./Select.types";
import { colors } from "@permisso/permisso-components";

export const Select = ({
  value,
  options,
  title,
  placeholder,
  color = colors.grey700,
  variant = "outline",
  error,
  disabled = false,
  dataTestId,
  setSelectedValue,
}: SelectProps) => {
  const { blackColor } = useTheme();
  const disabledStyles = disabled
    ? {
        background: colors.grey300,
        opacity: 1,
        cursor: "not-allowed",
        color: value ? blackColor : colors.grey500,
        WebkitTextFillColor: value ? blackColor : colors.grey500,
      }
    : undefined;

  return (
    <SelectContainer $disabled={disabled}>
      {title ? <Title>{title}</Title> : null}
      <ChakraSelect
        placeholder={placeholder}
        value={value}
        data-testid={dataTestId}
        isInvalid={!!error}
        onChange={(e) => {
          setSelectedValue(e.target.value);
        }}
        color={color}
        variant={variant}
        disabled={disabled}
        _disabled={disabledStyles}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.key}
          </option>
        ))}
      </ChakraSelect>
    </SelectContainer>
  );
};

const SelectContainer = styled.div<{ $disabled: boolean }>`
  :hover {
    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  }
`;

const Title = styled(Text)`
  padding-bottom: 0.25rem;
`;
